import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_staff/it-operation-core/_detail/operation-instances/$instanceId/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/it-operation-core/operation-instances/$instanceId/detail',
      params: { instanceId: params.instanceId },
    });
  },
});
